import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MergeWhite from "../assets/images/merge-white.png";
import {
  getAllAcumaticaProjects,
  getCostCodesByProjectId,
  getProjectTask,
  getProjectTaskAndCostCode,
  mergeProjectAndTasks,
} from "../API";

const MergeProjectModal = (props) => {
  const { projectId } = props;
  const [tempProjectTasks, setTempProjectTasks] = useState([]);
  const [getProjectList, setAllProjectOptions] = useState([]);
  const [costCodeList, setCostCodeList] = useState();
  const [tasksList, setTasksList] = useState([]);
  const [selectedProject, setSelectedProject] = useState({});
  const [selectedProjectTasks, setSelectedProjectTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedAcumaticaTask, setSelectedAcumaticaTask] = useState([]);
  const [selectedAcumaticaCostCode, setSelectedAcumaticaCostCode] = useState(
    []
  );

  const resetFields = () => {
    setSelectedAcumaticaTask([]);
    setSelectedAcumaticaCostCode([]);
    setSelectedProject({});
    setSelectedProjectTasks([]);
  };

  const navigate = useNavigate();

  useEffect(() => {
    getAllTempProjects();
    getAllAcumaticaTasks();
  }, []);

  const getAllTempProjects = async () => {
    await getAllAcumaticaProjects().then((res) => {
      if (res.status === 200) {
        const tempProjectDetails = res?.data?.map((project) => {
          return {
            label: `(${project?.acumatica_project_id}) ${project?.description}`,
            value: project?.id,
          };
        });
        setAllProjectOptions(tempProjectDetails);
      }
    });
  };

  const getAllAcumaticaTasks = async () => {
    const query = `project_id=${projectId}`;
    await getProjectTaskAndCostCode(query).then((res) => {
      if (res.status === 200) {
        const projectTasks = res?.data?.map((task) => {
          return { label: task?.task, value: task };
        });
        setTempProjectTasks(projectTasks);
      }
    });
  };

  const fetchCostCodes = async (data, index) => {
    const payload = {
      id: selectedProject?.value,
      is_default: true,
      query: `project_task_id=${data?.value?.id}`,
    };
    await getCostCodesByProjectId(
      payload?.id,
      payload?.is_default,
      payload?.query
    ).then((res) => {
      const projectCostCodeOptions = res?.data?.map((costCode) => ({
        label: `${costCode?.description} (${costCode?.cost_code})`,
        value: costCode,
        index: index,
      }));

      setCostCodeList((prevState) => {
        let newCostCodeList = Array.isArray(prevState) ? [...prevState] : [];
        newCostCodeList = newCostCodeList.filter(
          (costCode) => costCode.index !== index
        );
        if (projectCostCodeOptions.length > 0) {
          newCostCodeList.push(...projectCostCodeOptions);
        }
        return newCostCodeList;
      });
    });
  };

  const handleAcumaticaTaskChange = (data, tempTask, index) => {
    setSelectedAcumaticaCostCode((prevState) =>
      prevState.filter((ele) => ele.index !== index)
    );
    setSelectedAcumaticaTask((prevState) => {
      const existingIndex = prevState.findIndex((task) => task.index === index);
      if (existingIndex !== -1) {
        const updatedState = [...prevState];
        updatedState[existingIndex] = { ...data, index };
        return updatedState;
      }
      return [...prevState, { ...data, index }];
    });
    fetchCostCodes(data, index);
    const source_task = tempTask?.value?.task_id;
    const destination_task = data?.value?.id;

    setSelectedProjectTasks((prevState) => {
      const prevIndex = prevState?.findIndex((ele) => ele?.index === index);
      if (prevIndex >= 0) {
        prevState[prevIndex].source_task = source_task;
        prevState[prevIndex].destination_task = destination_task;
        return [...prevState];
      } else {
        return [...prevState, { source_task, destination_task, index }];
      }
    });
  };

  const handleAcumaticaCostCodeChange = (data, tempCostCode, index) => {
    setSelectedAcumaticaCostCode((prevState) => {
      const existingIndex = prevState.findIndex(
        (costCode) => costCode.index === index
      );
      if (existingIndex !== -1) {
        const updatedState = [...prevState];
        updatedState[existingIndex] = { ...data, index, tempCostCode };
        return updatedState;
      }
      return [...prevState, { ...data, index, tempCostCode }];
    });

    const source_cost_code = tempCostCode?.value?.cost_code_id;
    const destination_cost_code = data?.value?.id;

    setSelectedProjectTasks((prevState) => {
      const prevIndex = prevState?.findIndex((ele) => ele?.index === index);
      if (prevIndex >= 0) {
        prevState[prevIndex].source_cost_code = source_cost_code;
        prevState[prevIndex].destination_cost_code = destination_cost_code;
        return [...prevState];
      } else {
        return [
          ...prevState,
          { source_cost_code, destination_cost_code, index },
        ];
      }
    });
  };

  const handleProjectChange = async (data) => {
    setLoading(true);
    setSelectedProject(data);
    setSelectedProjectTasks([]);
    setCostCodeList([]);
    setSelectedAcumaticaTask([]);
    setSelectedAcumaticaCostCode([]);
    await getProjectTask(data?.value)
      .then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          const projectTasks = res?.data?.map((task) => {
            return { label: task?.description, value: task };
          });
          setTasksList(projectTasks);
          setSelectedProjectTasks([]);
        }
      })
      .catch((err) => setLoading(false));
    // await getProjectTaskAndCostCode(query)
    //   .then((res) => {
    //     setLoading(false);
    //     if (res?.status === 200) {
    //       const projectTasks = res?.data?.map((task) => {
    //         return { label: task?.task, value: task };
    //       });
    //       setTasksList(projectTasks);
    //       setSelectedProjectTasks([]);
    //     }
    //   })
    //   .catch((err) => setLoading(false));
  };

  const onClickMerge = async () => {
    if (
      projectId &&
      selectedProject?.value &&
      selectedProjectTasks?.length === tempProjectTasks?.length &&
      selectedAcumaticaCostCode?.length === tempProjectTasks?.length
    ) {
      const allSelectedProjectTasks = selectedProjectTasks.map(
        ({ index, ...rest }) => rest
      );
      const payload = {
        project: {
          source: parseInt(projectId),
          destination: selectedProject.value,
        },
        project_task_code_code: allSelectedProjectTasks,
      };
      await mergeProjectAndTasks(payload)
        .then((res) => {
          if (res?.status === 200) {
            toast.success("Project merged successfully");
            resetFields();
            navigate("/projects");
          }
        })
        .catch((error) => {
          toast.error("Something went wrong");
        });
    } else {
      toast.warning("Please enter the required fields");
    }
  };

  const getCostCodes = (index) => {
    return costCodeList?.filter((ele) => ele?.index === index);
  };

  const getSelectedTask = (index) => {
    const findSelectedTask = selectedAcumaticaTask?.find(
      (ele) => ele?.index === index
    );
    return findSelectedTask || null;
  };

  const getSelectedCostCode = (index) => {
    const findSelectedCostCode = selectedAcumaticaCostCode?.find(
      (ele) => ele?.index === index
    );
    return findSelectedCostCode || null;
  };

  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="mergeProjectModal"
        tabIndex="-1"
        aria-labelledby="mergeProjectModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog"
          style={{ maxHeight: "600px", minWidth: "60%", Width: "100%" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="mergeProjectModalLabel"
              >
                Merge project
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetFields()}
              ></button>
            </div>
            <div className="offcanvas-body">
              <div className="add-new-project-modal">
                <div className="input-flex">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Select project
                  </label>
                  <div className="col-xl-12">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      loading={loading}
                      placeholder="Select"
                      value={selectedProject}
                      onChange={(data) => handleProjectChange(data)}
                      aria-label="Default select example"
                      options={getProjectList}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: "350px",
                    overflowY: "scroll",
                    paddingTop: "15px",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <th
                        style={{
                          width: "35%",
                        }}
                        colspan="2"
                      >
                        Temporary project
                      </th>
                      <th colspan="2">Acumatica project</th>
                    </tr>
                    <tr>
                      <td>Task</td>
                      <td>Cost code</td>
                      <td
                        style={{
                          width: " 150px",
                        }}
                      >
                        Task
                      </td>
                      <td
                        style={{
                          width: " 150px",
                        }}
                      >
                        Cost code
                      </td>
                    </tr>

                    {tempProjectTasks?.length > 0 ? (
                      tempProjectTasks?.map((task, index) => {
                        return (
                          <tr>
                            <td>{task?.label}</td>
                            <td>{task?.value?.cost_code}</td>
                            <td>
                              <Select
                                classNamePrefix="select-input"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                value={getSelectedTask(index)}
                                loading={loading}
                                placeholder="Select"
                                onChange={(data) =>
                                  handleAcumaticaTaskChange(data, task, index)
                                }
                                aria-label="Default select example"
                                options={tasksList}
                              />
                            </td>
                            <td>
                              <Select
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                value={getSelectedCostCode(index)}
                                loading={loading}
                                placeholder="Select"
                                onChange={(data) =>
                                  handleAcumaticaCostCodeChange(
                                    data,
                                    task,
                                    index
                                  )
                                }
                                aria-label="Default select example"
                                options={getCostCodes(index)}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        <p>NA</p>
                        <p>NA</p>
                      </>
                    )}
                  </table>
                </div>
              </div>
              <div>
                {tempProjectTasks?.length > 0 && (
                  <div className="add-new-project-footer">
                    <button
                      data-bs-dismiss="modal"
                      type="button"
                      className="primary-btn-less-width"
                      aria-label="Close"
                      onClick={() => onClickMerge()}
                    >
                      <img className="merge-logo-styles" src={MergeWhite} />
                      Merge
                    </button>
                    {loading && (
                      <div
                        className="spinner-border loader-styles"
                        role="status"
                      ></div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MergeProjectModal;
